import { adminLedgerAccountsV2, adminRecordInspector } from 'rails_routes'

import { useGetLedgerAccount } from '../../hooks/useGetLedgerAccount'
import { formatMoney } from '../../utils'

interface LedgerAccountInfoProps {
  ledgerAccountId?: string
  cutoff?: string
}

function LedgerAccountInfoImpl ({ ledgerAccountId, cutoff }: LedgerAccountInfoProps) {
  const { data: account, isLoading, isError } = useGetLedgerAccount({ id: ledgerAccountId, cutoff })

  if (isLoading) {
    return (
      <div className='bg-white p-4 rounded-md shadow-sm mb-4'>
        <p>Loading...</p>
      </div>
    )
  }

  if (isError) {
    return (
      <div className='bg-white p-4 rounded-md shadow-sm mb-4'>
        <p className='text-red-500'>Error loading account details</p>
      </div>
    )
  }

  return (
    <div className='bg-white p-4 rounded-md shadow-sm mb-4'>
      <h2 className='text-lg font-semibold mb-3'>Account</h2>
      <div className='grid grid-cols-2 gap-4'>
        <div>
          <p className='text-sm text-gray-500'>Ledger ID</p>
          <p className='font-medium'>
            {ledgerAccountId
              ? <a href={adminRecordInspector.show({ id: ledgerAccountId })}>{ledgerAccountId}</a>
              : '-'}
          </p>
        </div>
        <div>
          <p className='text-sm text-gray-500'>Ledger Path</p>
          <p className='font-medium'>{account?.path || '-'}</p>
        </div>
        <div>
          <p className='text-sm text-gray-500'>Total Balance</p>
          <p className='font-medium'>{account ? formatMoney(account.total_balance) : '-'}</p>
        </div>
        <div>
          <p className='text-sm text-gray-500'>Parent Account</p>
          <p className='font-medium'>
            {account?.parent?.id
              ? (
                <a href={adminLedgerAccountsV2.index({ query: { id: account.parent.id } })}>
                  {account.parent.path}
                </a>
                )
              : '-'}
          </p>
        </div>
      </div>
    </div>
  )
}

const LedgerAccountInfo = ({ ledgerAccountId, cutoff }: LedgerAccountInfoProps) => {
  return (
    <LedgerAccountInfoImpl ledgerAccountId={ledgerAccountId} cutoff={cutoff} />
  )
}

export default LedgerAccountInfo
